import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type ImportOptions =
  | 'import-from-drive'
  | 'import-from-box'
  | 'import-from-dropbox'
  | 'import-from-brandfolder'
  | 'import-from-canto'
  | 'import-from-sharePoint'
  | 'import-from-frameio';

export type TrackClickedImport = {
  location: AirActionTrackingLocation;
  origin: ImportOptions;
};

export const useTrackClickedImport = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedImport = useCallback(
    (params: TrackClickedImport) => {
      track(`Clicked Import`, params);
    },
    [track],
  );

  return { trackClickedImport };
};
